module.exports = __webpack_public_path__ + "img/18.15bb15a5.jpg";